<div class="ios-dialog">
    <button type="button" class="close-btn" aria-label="Close" (click)="close()">&times;</button>
    <div class="ios-header">
        <div class="ios-icon">
            <svg viewBox="0 0 24 24" width="28" height="28" fill="#fff" aria-hidden="true">
                <path d="M16.37 12.64c-.02-2.2 1.8-3.26 1.88-3.31-1.02-1.5-2.62-1.7-3.19-1.73-1.36-.14-2.65.8-3.34.8-.69 0-1.75-.78-2.88-.76-1.48.02-2.85.86-3.61 2.19-1.54 2.67-.39 6.62 1.1 8.79.73 1.06 1.6 2.25 2.74 2.21 1.1-.04 1.52-.71 2.85-.71 1.33 0 1.71.71 2.88.69 1.19-.02 1.94-1.08 2.66-2.15.84-1.23 1.19-2.42 1.21-2.48-.03-.01-2.3-.88-2.3-3.54zM14.2 6.1c.6-.73 1.01-1.75.9-2.76-.87.04-1.92.58-2.54 1.31-.56.65-1.05 1.69-.92 2.68.97.07 1.96-.49 2.56-1.23z"/>
            </svg>
        </div>
        <div>
            <h2>Download AI advisor iOS app</h2>
            <p>Enterprise Edition for J&amp;J MedTech</p>
        </div>
    </div>
    <div class="qr-wrapper">
        <div class="qr-box">
            <img src="../../../assets/images/AI_Advisor_QRcode.png" alt="AI Advisor iOS app QR code" />
        </div>
    </div>
    <p class="scan-text">Scan with your iPhone camera to install via Apple App Store.</p>
    <div class="badges">
        <span class="badge">
            <img class="store-link-icon" src="../../../assets/images/apple-logo-svgrepo-com.svg" />
            iOS 18+</span>
    </div>
    <div class="link-row">
        <input type="text" readonly [value]="appStoreUrl" aria-label="App Store link" />
        <button type="button" class="store-btn" (click)="openAppStore()">
        <mat-icon class="store-link-icon">open_in_new</mat-icon>
App Store Link</button>
    </div>
</div>
